import React, {Component} from 'react'
import {Button} from "antd"
import BatchRecycle from "./batch-actions/BatchRecycleV2"
import ExportBatch from "./batch-actions/ExportBatch"
import ExportDetailError from "./batch-actions/ExportDetailError"
import ExportBatchCSV from "./batch-actions/ExportBatchCSV"
import BatchMerge from "./batch-actions/BatchMerge"
import ChangeStatusSewing from './batch-actions/ChangeStatusSewing'
import { getLocalData } from '../../../services/StorageServices'
import { parseJwt } from '../../../helpers/parseToken'
import ChangeStatusTransferred from "./batch-actions/ChangeStatusTransferred"
import {recycleBatchV2,recycleBatchDetails} from "../../../services/api/3dApi"

class BatchActions extends Component {
    render() {
        const {changeContent, showButton, batch, match, history, onShowHistory, status, refreshBatchInfo, isShowButtonPieceError} = this.props
        const {merge_file_status = 'created'} = batch
        // const role = parseJwt(getLocalData('accessToken')).roles
        // const isAdmin= role.some(item=> item.name==="Super Admin")
        
        return (
            <div className='d-flex flex-wrap align-items-center'>
                {/* {isAdmin&&
                    <ChangeStatusTransferred batch={batch}  refreshBatchInfo={refreshBatchInfo}/>
                }

                {isAdmin&&
                    <ChangeStatusSewing batch={batch}  refreshBatchInfo={refreshBatchInfo}/>
                } */}
                <BatchMerge id={batch._id} merge_file_status={merge_file_status} refreshBatchInfo={refreshBatchInfo}/>
                <Button icon={!changeContent ? 'exclamation-circle' : 'info-circle'}
                        type={changeContent ? 'primary' : ''}
                        className='mr-3 mt-2'
                        onClick={onShowHistory}>{!changeContent ? 'Xem lịch sử' : 'Chi tiết lô'}</Button>
                <ExportBatchCSV
                    changeContent={changeContent}
                    match={match}
                    history={history}
                    status={status}
                />
                <ExportBatch
                    changeContent={changeContent}
                    match={match}
                    history={history}
                    status={status}
                />
                <ExportDetailError
                    changeContent={changeContent}
                    match={match}
                />
                {
                    showButton && batch.hasOwnProperty('_id') && 
                        <BatchRecycle
                            level={batch.level_number !== undefined && batch.level_number.toString()}
                            partner={batch.partner}
                            user={batch.user_create}
                            id={match.params.id}
                            history={history}
                            changeContent={changeContent}
                            recycleBatchV2={recycleBatchV2}
                            title="Tái tạo lô"
                        />
                    }
                {
                    showButton && batch.hasOwnProperty('_id') && isShowButtonPieceError &&
                        <BatchRecycle
                            level={batch.level_number !== undefined && batch.level_number.toString()}
                            partner={batch.partner}
                            user={batch.user_create}
                            id={match.params.id}
                            history={history}
                            changeContent={changeContent}
                            recycleBatchV2={recycleBatchDetails}
                            title="Tái tạo lô bù chi tiết"
                        />
                }
            </div>
        )
    }
}

export default BatchActions